import React, { useEffect, useState } from 'react';
import { MapPin, Map } from 'lucide-react';
import { seatMapApi } from '../../../services/api';

const VenueScheduleStep = ({ formData, errors, venues, handleInputChange }) => {
  const [charts, setCharts] = useState([]);
  const [loadingCharts, setLoadingCharts] = useState(false);

  useEffect(() => {
    loadSeatMaps();
  }, []);

  const loadSeatMaps = async () => {
    try {
      setLoadingCharts(true);
      const response = await seatMapApi.listCharts();
      // Handle different response structures (direct array or wrapper)
      const data = response.data?.data || response.data || response;
      setCharts(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load seat maps:', error);
    } finally {
      setLoadingCharts(false);
    }
  };

  const isSeatedEvent = formData.seatingMode === 'SEATED' || formData.seatingMode === 'MIXED';

  return (
    <div className="form-section">
      <h3><MapPin size={24} /> Venue Setup</h3>
      <p>Configure your venue location and seating arrangements.</p>

      <div className="form-field required">
        <label>Venue</label>
        <select
          value={formData.venueId}
          onChange={(e) => handleInputChange('venueId', e.target.value)}
          className={`wizard-select ${errors.venueId ? 'error' : ''}`}
        >
          <option value="">Select Venue</option>
          {venues.map((venue) => (
            <option key={venue.id} value={venue.id}>
              {venue.name}
              {venue.city || venue.state ? ` (${[venue.city, venue.state].filter(Boolean).join(', ')})` : ''}
            </option>
          ))}
        </select>
        {errors.venueId && <div className="error-message">{errors.venueId}</div>}
        {errors.venues && <div className="error-message">{errors.venues}</div>}
      </div>



      {/* Seating Chart Selection - Only for Seated/Mixed events */}
      {isSeatedEvent && (
        <div className="form-field">
          <label><Map size={14} /> Seating Chart Template (Optional)</label>
          <select
            value={formData.isNewChart ? 'new' : (formData.seatsIoChartKey || '')}
            onChange={(e) => {
              const val = e.target.value;
              handleInputChange('seatsIoChartKey', val);
              handleInputChange('isNewChart', val === 'new');
              handleInputChange('chartConfigured', false);
            }}
            className="wizard-select"
            disabled={loadingCharts}
          >
            <option value="">Select a template...</option>
            <option value="new">Create New Blank Chart</option>
            {charts.map((chart) => (
              <option key={chart.key} value={chart.key}>
                {chart.name}
              </option>
            ))}
          </select>
          <div className="hint-text">
            We will create a specific copy for this event.
          </div>

          {/* Duplication Option - Only show if a chart is selected AND not "new" (freshly created) */}
          {formData.seatsIoChartKey && formData.seatsIoChartKey !== 'new' && !formData.isNewChart && (
            <div className="radio-group" style={{ marginTop: '15px' }}>
              <label className="radio-option">
                <input
                  type="radio"
                  name="useSharedChart"
                  checked={!formData.useSharedChart}
                  onChange={() => handleInputChange('useSharedChart', false)}
                />
                <span className="radio-label">
                  <strong>Duplicate this chart (Recommended)</strong>
                  <br />
                  <span className="text-muted text-sm">Creates a unique copy for this event. Changes won't affect other events.</span>
                </span>
              </label>

              <label className="radio-option" style={{ marginTop: '10px' }}>
                <input
                  type="radio"
                  name="useSharedChart"
                  checked={formData.useSharedChart}
                  onChange={() => handleInputChange('useSharedChart', true)}
                />
                <span className="radio-label">
                  <strong>Use shared chart</strong>
                  <br />
                  <span className="text-danger text-sm">
                    Uses the exact same chart. <strong>Warning:</strong> Changes will affect all events using this chart.
                  </span>
                </span>
              </label>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default VenueScheduleStep;

